import api from '../../api'
const recurrenceAPI = api.create('recurrence')

const get = async ({ settingId = '' }) => {
  return await recurrenceAPI.get(`/settings/${settingId}`)
}

const update = async ({ settingId = '', value = '' }) => {
  return await recurrenceAPI.put(`/settings/${settingId}?value=${value}`)
}

export default {
  get,
  update,
}
